import { GoogleGenerativeAI } from "@google/generative-ai";
import { GEMINI_API_KEY } from '../utils/env';

const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);

export const socialMediaService = {
  async generateContent(params) {
    try {
      const model = genAI.getGenerativeModel({ model: "gemini-1.5-pro" });
      
      const { postInput, brandVoice, platform, contentType, targetAudience, keyObjectives, customHashtags } = params;
      
      const prompt = `Create a natural, conversational ${platform} post about: ${postInput}

      Personality Guide:
      - Write as a real person sharing authentic thoughts and experiences
      - Use a ${brandVoice} tone that feels genuine and relatable
      - Focus on ${contentType.replace('_', ' ')} in a way that resonates with ${targetAudience}
      - Aim to ${keyObjectives.join(' and ')} through authentic connection
      - Include relevant hashtags naturally: ${customHashtags}

      Key Elements:
      - Start with a hook that draws people in naturally
      - Share genuine thoughts or experiences
      - Ask questions to encourage real conversation
      - Use natural language and avoid corporate speak
      - Use emojis sparingly and authentically
      - End with an engaging question or genuine call to action

      Platform-Specific Style:
      - LinkedIn: Professional but human, share real experiences
      - Facebook: Friendly and community-focused, like talking to friends
      - Instagram: Authentic and relatable, focus on storytelling
      - Twitter: Casual and conversational, join the discussion naturally
      - Blog: Personal and detailed, like having a deep conversation
      - Newsletter: Friendly and direct, like writing to a friend

      Make it feel like a real person is sharing their thoughts, not a brand pushing content.
      ${platform === 'newsletter' ? 'For newsletter, include a personal, engaging subject line prefixed with "Subject:" on the first line.' : ''}`;

      const result = await model.generateContent(prompt);
      const response = await result.response;
      const text = response.text();
      
      return {
        content: text,
        error: null
      };
    } catch (error) {
      console.error('Error generating content:', error);
      return {
        content: null,
        error: error.message || 'Failed to generate content'
      };
    }
  }
}; 